import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ProductService} from '../../../../services/product.service';
import {Attribute} from '../../../../models/attribute';

@Component({
    selector: 'app-product-filter-type-checkbox',
    templateUrl: './product-filter-type-checkbox.component.html',
    styleUrls: ['./product-filter-type-checkbox.component.css']
})
export class ProductFilterTypeCheckboxComponent implements OnInit, OnDestroy {

    filterChanged;
    @Input('attribute') attribute: Attribute;
    @Input('options') options: any[];
    selectedOptions = [] ;
    constructor(private productService: ProductService) {


    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {

        if (this.filterChanged) {
            this.filterChanged.unsubscribe();
        }
    }

    checkBoxSelected(option_id , attr_id) {

         const obj = {
             'attr_id' : attr_id,
            'option_id' : option_id

         };



         if (this.selectedOptions.some(option => option.option_id === option_id)) {
             const index = this.selectedOptions.findIndex(object => {
                 return object.option_id === option_id;
             });
             this.selectedOptions.splice(index , 1) ;
         } else {

             this.selectedOptions.push(obj) ;
         }



        this.productService.EmitproductFilterChanged(this.selectedOptions);

    }

}
